import React, { useMemo } from 'react'
import { components } from 'react-select'
import _ from 'lodash'

import styles from './CheckboxSelect.module.css'

import ReactSelect from '../ReactSelect'
import Checkbox from 'Design/components/Checkbox'

const DEFAULT_SELCTED_LABEL = '$count items selected'

const CheckBoxOption = (props) => {
  const handleChange = _.noop

  return (
    <components.Option {...props}>
      <div className={styles.CheckboxContainer}>
        <Checkbox checked={props.isSelected} onChange={handleChange} />
        <label className={styles.CheckboxLabel}>{props.label}</label>
      </div>
    </components.Option>
  )
}

const CheckBoxGroup = (props) => {
  const groupOptionValues = props.options.map((opt) => opt.value)
  const allSelected = props.children.every((opt) => opt.props.isSelected)

  const allValues = props.getValue()

  const optionsToSelect = useMemo(() => {
    const valuesWithoutGroupOptions = allValues.filter((opt) => !groupOptionValues.includes(opt.value))

    if (allSelected) {
      return valuesWithoutGroupOptions
    }

    return [...valuesWithoutGroupOptions, ...props.options]
  }, [allSelected, allValues, groupOptionValues, props.options])

  const toggleAllSelection = () => props.selectProps.onChange(optionsToSelect)

  return <components.Group {...props} headingProps={{ ...props.headingProps, allSelected, toggleAllSelection }} />
}

const MultiValue = (props) => {
  if (props.index !== 0) {
    return null
  }

  const { selectedLabelPrefix = DEFAULT_SELCTED_LABEL } = props

  const renderString = selectedLabelPrefix.replace(/\$count/, props.selectProps.value.length)

  return renderString
}

const customStyles = {
  option: (provided, state) => {
    const hasFocusOrSelection = state.isSelected

    const styles = _.pickBy(
      {
        backgroundColor: hasFocusOrSelection ? 'var(--white)' : '',
        color: hasFocusOrSelection ? 'var(--text-color)' : ''
      },
      _.identity
    )

    return { ...provided, ...styles }
  }
}

const CheckboxSelect = (props) => {
  const { selectedLabelPrefix, ...rest } = props
  return (
    <ReactSelect
      {...rest}
      styles={customStyles}
      isMulti
      isSearchable={false}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      selectedLabelPrefix
      components={{
        ...props.components,
        Option: CheckBoxOption,
        Group: CheckBoxGroup,
        MultiValue: (multiValueProps) => {
          return <MultiValue {...multiValueProps} selectedLabelPrefix={selectedLabelPrefix} />
        }
      }}
    />
  )
}

export default CheckboxSelect
